import { ReactNode } from "react";
import tw from "src/utils/tw";

interface Props {
  children: ReactNode;
  className?: string;
}

export function Badge(props: Props) {
  return (
    <div
      className={tw(
        "bg-borderGray",
        "text-empty",
        "rounded px-2 pb-1 pt-1 font-bold leading-none",
        props.className
      )}
    >
      {props.children}
    </div>
  );
}
